import React, { Component } from 'react'
import Input from './../input'
import Radio from './../radio'
import _ from 'underscore'
import BVTextArea from './../textarea'
import { PROTOCOL } from './../../lib/helper'

class KinstaFormInputFields extends Component{
	constructor(props) {
		super(props)
		this.state = {}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
	}

	fetchValue(key) {
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key) {
		const { errors, fields } = this.props
		let classname
		if (key == "address") {
			classname = "col-md-9 col-xs-9"
		} else if (key == "port") {
			classname = "col-md-3 col-xs-3"
		} else {
			classname = "col-md-12 col-xs-12"
		}
		if (_.contains(errors, key)) {
			classname += " error-field"
		}
		return classname
	}

	render() {
		return (
			<div>
				<p className="bv-form-title" style={{textAlign: "left"}}>Enter sFTP Details of the new site that you want to migrate to</p>
				<div className="row">
					<div className={this.getClassName('newurl')}>
						<i className="mdi mdi-web"></i>
						<Input
							type="text"
							name="newurl"
							title="Destination Site URL"
							placeholder="Eg. www.google.com"
							classname=""
							value={this.fetchValue('newurl')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('address')}>
						<i className="mdi mdi-server"></i>
						<Input
							type="text"
							name="address"
							title="sFTP Host/Server Address"
							placeholder="Eg. 127.0.0.1"
							classname=""
							value={this.fetchValue('address')}
						/>
					</div>
					<div className={this.getClassName('port')} >
						<Input style={{overflow:'hidden', paddingLeft: '10px'}}
							type="number"
							name="port"
							title="Port"
							placeholder=""
							classname=""
							value={this.fetchValue('port')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('username')}>
						<i className="mdi mdi-account"></i>
						<Input
							type="text"
							name="username"
							title="sFTP Username"
							placeholder="Enter sFTP username here"
							classname=""
							value={this.fetchValue('username')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('passwd')}>
						<i className="mdi mdi-lock"></i>
						<Input
							type="password"
							name="passwd"
							title="sFTP Password"
							placeholder="Enter sFTP password here"
							classname=""
							value={this.fetchValue('passwd')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('path')}>
						<i className="mdi mdi-folder"></i>
						<Input
							type="text"
							name="path"
							title="Directory Path"
							placeholder="Eg. /var/www/html"
							classname=""
							value={this.fetchValue('path')}
						/>
					</div>
				</div>
				<div className="row hide-field">
					<Input
						type="hidden"
						name="migrate"
						value="kinsta"
						title=""
						placeholder=""
						classname=""
					/>
					<Input
						type="hidden"
						title=""
						name="type"
						placeholder=""
						classname=""
						value="sftp"
					/>
					<Input
						type="hidden"
						title=""
						name="protocol"
						placeholder=""
						classname=""
						value={PROTOCOL.SFTP}
					/>
				</div>
			</div>
		)
	}
}

export default KinstaFormInputFields
